import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import { ExternalProjectImportPreview } from '@provision/entity-types';
import { ProjectPreviewSection } from './project-preview-section';

export type ProjectPreviewProps = ExternalProjectImportPreview;

export const ProjectPreview = (props: ProjectPreviewProps) => {
  const panelId = `project-preview-${props.id}`;

  const renderSection = (
    label: string,
    entities: ExternalProjectImportPreview['created'],
  ) => {
    if (!entities?.length) {
      return null;
    }
    return (
      <Stack spacing={1}>
        <Typography variant="subtitle2" color="text.secondary">
          {label}
        </Typography>
        <Stack spacing={1}>
          {entities.map((entity) => (
            <ProjectPreviewSection entity={entity} key={`${entity.entity}-${entity.name}`} />
          ))}
        </Stack>
      </Stack>
    );
  };

  return (
    <div>
      <Accordion
        disableGutters
        sx={{
          borderRadius: 2,
          backgroundColor: 'background.default',
          boxShadow: 'none',
          border: '1px solid',
          borderColor: 'divider',
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`${panelId}-content`}
          id={`${panelId}-header`}
          sx={{
            px: 3,
            py: 2,
            '& .MuiAccordionSummary-content': {
              margin: 0,
            },
          }}
        >
          <Stack direction="column" spacing={0.5} width="100%">
            <Typography component="span" variant="subtitle1">
              {props.projectName}
            </Typography>
            <Typography component="span" variant="body2" color="text.secondary">
              {props.address || 'No address'}
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{ px: 3, pb: 3, pt: 0 }}>
          <Stack spacing={2}>
            {renderSection('Create:', props.created)}
            {renderSection('Update:', props.updated)}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
